import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import BottomMenu from './BottomMenu';
import SidebarPanel from './SidebarPanel';

class CustomerOrderTrack extends React.Component {
    constructor(props) {
        //console.log(props);
        super(props);
        this.state = {
            LOCATION: this.props.location.pathname,
            LOADING: true, 
            id: props.match.params.id,
            showModal: props.match.params.showModal || 'N',
            orderStatus: '',
            orderTimeline: [],
            CUSTOMER_DET: ''
        };
    }

    fetchCustomerOrders(mode,customer,order_id) {
        var that = this;
        fetch('https://m.donedelivery.in/api/customerordertrack_api.php?mode='+mode+'&customer='+customer+'&id='+order_id,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            
            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
            
            that.setState({ LOADING:false, orderStatus:result.status, orderTimeline:result.timeline, CUSTOMER_DET:CUSTOMER_DET });
            if(that.state.showModal=='Y')
                $('#OrderPlacedModal').modal('show');
        });
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }

        let customer = '';

        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');
        this.fetchCustomerOrders('TRACK_ORDER',customer,this.state.id);
    }

    componentDidMount() {
        setTimeout(() => {
            //window.location.href = "/ordertrack/"+this.state.id;
            let customer = '';

            if(localStorage.getItem('userData'))
                customer = localStorage.getItem('userData');
            this.fetchCustomerOrders('TRACK_ORDER',customer,this.state.id);
        }, 60000)
    }

    render() {
        
        let Verified = '';
        if(localStorage.getItem('Verified') !== null && localStorage.getItem('Verified')!=='{}')
        {
            if(localStorage.getItem('userData'))
                Verified = localStorage.getItem('Verified');
        }
        else
            Verified = 'N';

        if(Verified=='N')
        {
            return (<Redirect to={'/verifyMobile'}/>);
        }
        
        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/orders';
        let AppHeaderTitle = 'Order Status';
        let AppHeaderRight = '';
        let AppHeaderRightLink = '';
        let AppHeaderSearch = '';

        //console.log(this.props);
        return (
            <div>
                {this.state.LOADING && <Loader /> }
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
                <div id="appCapsule">
                    <div className="section full mt-2">
                        <div className="section-title">Order ID: {this.state.id}</div>
                        {this.state.orderStatus && <div className="content-header mb-05">STATUS : {this.state.orderStatus}</div>}
                        <div className="wide-block">
                            <div className="timeline">
                                {this.state.orderTimeline && 
                                    this.state.orderTimeline.map((post, i)=>{
                                        return (
                                        <div className="item" key={i}>
                                            <div className={`dot bg-${post.css}`}></div>
                                            <div className="content">
                                                <h4 className="title">{post.action}</h4>
                                                <div className="text">{post.date}</div>
                                            </div>
                                        </div>
                                        )
                                    })
                                 }
                            </div>
                        </div>
                    </div>
                    <div className="section mt-1 mb-5"> <br />
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-8">
                                <Link to={`/orderdetails/${this.state.id}`} className="btn square btn-danger btn-block">ORDER SUMMARY</Link>
                            </div>
                            <div className="col-2"></div>
                        </div>
                    </div>
                </div>
                <BottomMenu LOCATION={this.state.LOCATION} />
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
                {this.state.showModal=='Y' && 
                    <div className="modal fade dialogbox" id="OrderPlacedModal" data-backdrop="static" tabIndex="-1" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-icon text-success">
                                    <ion-icon name="checkmark-circle"></ion-icon>
                                </div>
                                <div className="modal-header">
                                    <h5 className="modal-title">Thank you for placing an order</h5>
                                </div>
                                <div className="modal-body">
                                    Your order <strong>#{this.state.id}</strong> will be delivered to you soon
                                </div>
                                <div className="modal-footer">
                                    <div className="btn-inline">
                                        <Link to={`/ordertrack/${this.state.id}`} className="btn" data-dismiss="modal">Order Status</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}
  
export default CustomerOrderTrack;


// WEBPACK FOOTER //
// ./src/components/CustomerOrderTrack.js